<template>
  <div class="FloorDetection">
    <Title firstName="楼层人员检测" lastName="FLOOR PERSONNEL DETECTION" />
    <div class="echarts">
        <div class="mark">
            主楼
            <span><img src="../../../../assets/img/floor4.png">无人</span>
            <span><img src="../../../../assets/img/floor3.png">有人</span>
        </div>
        <div class="floor" >
            <!-- <span  v-for="item in reverseSum" :class="{active:item==5}" :key="item">{{item}}F</span> -->
            <span  v-for="item in reverseSum" :class="{active:true}" :key="item">{{item}}F</span>
        </div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
const Title = () => import("../../../../components/title/Title");
export default {
  data() {
    return {
        allSum:[1,2,3,4,5]
    };
  },
  components: {
    Title,
  },
  mounted() {
   
  },
  methods: {
   
  },
  watch: {},
  computed: {
      reverseSum() {
            return this.allSum.reverse();
      }

  },
};
</script>

<style lang="less" scoped>
.FloorDetection {
  // height: 33.3vh;
  width: 20vw;
  // height: 493rem;
  position: fixed;
  top: 31.2vh;
  left: 2vw;
  z-index: 1;

   
  .echarts {
    position: relative;
    height: 25.5vh;
    padding-bottom: 1vh;
    background: linear-gradient(
      0deg,
      rgba(0, 33, 59, 0.6) 0%,
      rgba(3, 13, 24, 0.7) 100%
    );
    color: rgba(230, 243, 253, 0.7);

    .mark{
        
        padding:20rem 20rem 10rem 20rem;
        overflow: hidden;
        span{
            margin-left: 20rem;
            float: right;
            img{
                margin-right: 5rem;
                vertical-align: middle;
            }
        }
    }
    .floor{
        overflow: hidden;
        padding: 0 10rem;
        width: 105%;
        span{
            display: inline-block;
            width: 3.2vw;
            height: 5.5vh;
            text-align: center;
            line-height: 5.5vh;
            font-family: zcoolqingkehuangyouti;
            font-size: 24rem;
            margin: 0.4vw 0.3vw;
            background: url('../../../../assets/img/floor2.png') no-repeat center;
            background-size: 100% 100%;
        }
        .active{
            background: url('../../../../assets/img/floor.png') no-repeat center;
            background-size: 100% 100%;
        }
    }
    .bottom {
      width: 20vw;
      height: 1vh;
      background: url(../../../../assets/img/板块装饰线.png) no-repeat;
      block-size: 100% 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
.power1 {
  top: 30.3vh;
}
</style>
